import toast from "react-hot-toast";
import { log, supabase } from ".";
import { EDIFICIOS_EXCLUIDOS } from "../constants/permisos";

export const getEdificiosOperativos = async ({ pais }) => {
  try {
    // Asumiendo que supabase.select es la forma correcta de hacer la consulta en tu configuración
    const data = await supabase.select("edificios", {
      filters: {
        pais,
      },
      orderBy: "pantallas",
      ascending: false,
    });

    // Filtrar por estado OPERATIVO (igual que el Cotizador por defecto)
    // Excluir edificios 119 y 121 (igual que el Cotizador)
    const filteredData = data.filter(
      (edificio) => edificio.estado === "OPERATIVO" && !EDIFICIOS_EXCLUIDOS.includes(edificio.id)
    );

    if (filteredData.length === 0) {
      toast.error("No hay edificios cargados en la base de datos");
      throw new Error("No data found");
    }

    return filteredData;
  } catch (error) {
    log.error("getEdificiosOperativos", error);
    throw error;
  }
};
